import { render, staticRenderFns } from "./TableArrows.vue?vue&type=template&id=2020976f&scoped=true&"
import script from "./TableArrows.vue?vue&type=script&lang=js&"
export * from "./TableArrows.vue?vue&type=script&lang=js&"
import style0 from "./TableArrows.vue?vue&type=style&index=0&id=2020976f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020976f",
  null
  
)

export default component.exports